import React, { useMemo } from "react";
import TableAccordion from "../tableAccordion";
import { Button, SectionTitle, Text } from "../../styledComponent";
import { Loader, ScheduledBox } from "../../ui";
import { Clock } from "react-bootstrap-icons";
import locationTableStyles from "../locationTable/style.module.scss";

/**
 * Same desktop/mobile table layout as {@link ../locationTable | LocationTable},
 * without pagination — all rows render when `locationData` is provided.
 */
const AllLocationsLoadMoreTable = ({
  locationData,
  dataError,
  hideDistance = true,
}) => {
  const rows = useMemo(() => {
    if (!Array.isArray(locationData)) return null;
    return locationData;
  }, [locationData]);

  const total = rows?.length ?? 0;

  const s = locationTableStyles;

  return (
    <div className={s.tableBlock}>
      <div className={s.tableFilter}>
        <div className={s.displayData}>
          <Text $size="1.4rem" style={{ margin: 0 }}>
            {rows ? `${total} location${total === 1 ? "" : "s"}` : ""}
          </Text>
        </div>
      </div>
      <div className={s.locTable}>
        <table>
          <tbody>
            {rows ? (
              rows.length === 0 ? (
                <tr>
                  <td>
                    <Text style={{ textAlign: "center", margin: "0" }}>
                      No Location Found.
                    </Text>
                  </td>
                </tr>
              ) : (
                rows.map((data, i) => (
                  <tr key={`${data.store_name}-${data.address}-${i}`}>
                    <td>
                      <SectionTitle $size="1.4rem">
                        {data.store_name}
                      </SectionTitle>
                      <Text $size="1.4rem">{data.address}</Text>
                    </td>
                    <td>
                      <SectionTitle $size="1.4rem">Amenities</SectionTitle>
                      <Text $size="1.4rem">
                        {data.amenities &&
                          data.amenities.map((item, j) => (
                            <span key={j}>
                              {item.name},{""}
                            </span>
                          ))}
                      </Text>
                      <SectionTitle $size="1.4rem">Gas Types</SectionTitle>
                      <Text $size="1.4rem">
                        {data.gas_types &&
                          data.gas_types.map((item, j) => (
                            <span key={j}>
                              {item.name},{""}
                            </span>
                          ))}
                      </Text>
                    </td>
                    <td>
                      <div
                        style={{ position: "relative" }}
                        className={s.storeHours}
                      >
                        <Button $size="1.4rem" $weight="500">
                          <Clock />
                          <span>
                            {data.is24by7
                              ? "Open 24/7"
                              : "Click for store hours"}
                          </span>
                        </Button>
                        {!data.is24by7 && (
                          <ScheduledBox timings={data.timings} />
                        )}
                      </div>
                    </td>
                    {!hideDistance && (
                      <td>
                        <Text $size="1.4rem">{data.distance} km</Text>
                      </td>
                    )}
                    <td>
                      <Text $size="1.4rem">
                        <a
                          href={`http://maps.google.com/maps?q=${data.lat},${data.lng}&ll=${data.lat},${data.lng}&z=17`}
                        >
                          Directions
                        </a>
                      </Text>
                    </td>
                  </tr>
                ))
              )
            ) : dataError ? (
              <tr>
                <td>
                  <p style={{ textAlign: "center", fontSize: "1.8rem" }}>
                    There was an error while fetching the data
                  </p>
                </td>
              </tr>
            ) : (
              <tr>
                <td style={{ textAlign: "center" }}>
                  <Loader />
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className={s.tableAccord}>
          {rows ? (
            rows.length === 0 ? (
              <tr>
                <td>
                  <Text style={{ textAlign: "center", margin: "0" }}>
                    No Location Found.
                  </Text>
                </td>
              </tr>
            ) : (
              rows.map((data, i) => (
                <TableAccordion
                  key={`acc-${data.store_name}-${data.address}-${i}`}
                  storeName={data.store_name}
                  address={data.address}
                  amenities={data.amenities}
                  timings={data.timings}
                  distance={data.distance}
                  hideDistance={hideDistance}
                  lat={data.lat}
                  lng={data.lng}
                />
              ))
            )
          ) : dataError ? (
            <Text style={{ textAlign: "center", fontSize: "1.8rem" }}>
              There was an error while fetching the data
            </Text>
          ) : (
            <div style={{ textAlign: "center" }}>
              <Loader />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllLocationsLoadMoreTable;
